export default __webpack_public_path__ + "static/media/21.6e4b1de5.jpg";